import {
  useLmmOpenBenodigdOpbouw,
  useLmmOpenTijdstip,
  useLmmTijdstippen,
  useSetLmmOpenTijdstip,
} from '@/apps/lmm/state/selectors/useLmmVoorraadStore';

import { getLmmTijdstipColumnCount } from '../../utils/lmmTableColumns';
import { getLmmTijdstip, getLmmTijdstipDatum } from '../../utils/lmmTijdstippen';

import LmmExpandChevrons from './LmmExpandChevrons';

import styles from './LmmTableMaterieelTijdstipHeader.module.css';

export default function LmmTableMaterieelTijdstipHeader() {
  const lmmTijdstippen = useLmmTijdstippen();
  const lmmOpenTijdstip = useLmmOpenTijdstip();
  const lmmOpenBenodigdOpbouw = useLmmOpenBenodigdOpbouw();
  const setLmmOpenTijdstip = useSetLmmOpenTijdstip();

  return (
    <div className={styles.tijdstipHeader}>
      <div className={styles.fixedColumnsSpacer} />
      {lmmTijdstippen.map((tijdstip) => {
        const isOpen = tijdstip.label === lmmOpenTijdstip;
        const columnCount = getLmmTijdstipColumnCount(tijdstip.label, lmmOpenTijdstip, lmmOpenBenodigdOpbouw);
        return (
          // Wrapping div mirrors tijdstipGroup (LmmTableMaterieelHeaders/Row) exactly, so its
          // flex-grow based width lines up 1:1 with the columns below. A plain <button> as the
          // flex item itself does not shrink reliably to a flex-grow: 0 basis in some browsers,
          // even with min-width: 0, which threw the column borders out of alignment.
          <div key={tijdstip.label} className={styles.tijdstipGroup} style={{ flexGrow: columnCount }}>
            <button
              type='button'
              data-testid={`lmmTijdstip-${tijdstip.label}`}
              className={styles.tijdstipButton}
              onClick={() => setLmmOpenTijdstip(tijdstip.label)}
            >
              <div>
                {getLmmTijdstip(tijdstip)}
                <span> {getLmmTijdstipDatum(tijdstip)}</span>
              </div>
              <LmmExpandChevrons open={isOpen} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
